export enum ODFContactTypes {
  SC_UPC = 'SC/UPC',
  SC_APC = 'SC/APC',
  LC_UPC = 'LC/UPC',
  LC_APC = 'LC/APC',
}
